// This was generated during the migration to @kiwicom/eslint-config
// PLEASE REMOVE THE GLOBAL ESLINT DISABLE BELOW
// AND FIX ERRORS ACCORDINGLY.
/* eslint-disable func-names */
import type { PassengerId } from "@kiwicom/frontend-common/types/primitiveTypes"

import type { BookingId, ExtrasId } from "../../../../../../../types/primitiveTypes"
import { PASSENGER_EDIT } from "../../../scenes/BookingPassengerEdit/services/consts"

export type PassengerChange = {
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line babel/camelcase
  booking_id: BookingId
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line babel/camelcase
  created_at: number
  id: number
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line babel/camelcase
  is_automated: boolean
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line babel/camelcase, @typescript-eslint/array-type
  passenger_ids: Array<PassengerId>
  stage: string
  abid?: ExtrasId
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line babel/camelcase
  updated_at: number
}

export type PassengerChangeWithCategory = PassengerChange & {
  category: string
}

export type PassengerEditRequestsType = PassengerChange[]

export default function (
  passengerEditRequests: PassengerEditRequestsType = [],
): PassengerChangeWithCategory[] {
  return passengerEditRequests.map((change) => {
    return {
      ...change,
      category: PASSENGER_EDIT,
    }
  })
}
